var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgSmartphone = function SvgSmartphone(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "data-width-16": 10,
    "data-width-24": 15,
    viewBox: "0 0 10 14.8",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M7.985.6H1.83C1.15.6.6 1.151.6 1.83v11.078c0 .68.55 1.23 1.23 1.23h6.154c.68 0 1.23-.55 1.23-1.23V1.83c0-.68-.55-1.23-1.23-1.23M4.292 11.677h1.231"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSmartphone);
export default ForwardRef;